import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LucideAngularModule } from "lucide-angular";
import { UserService } from "../../services/user.service";
import { RouterService } from "../../services/router.service";
import { AuthenticationService } from "../../services/authentication.service";
import { LoginPromptService } from "../../services/login-prompt.service";

@Component({
  selector: "app-rb-rank",
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: "./rb-rank.component.html",
  styleUrl: "./rb-rank.component.css",
})
export class RbRankComponent implements OnInit {
  users: any[] = [];
  isLoading = true;
  currentUser: any;

  constructor(
    private userService: UserService,
    private routerService: RouterService,
    private authService: AuthenticationService,
    private loginPromptService: LoginPromptService,
  ) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit(): void {
    this.loadRankings();
  }

  loadRankings(): void {
    this.isLoading = true;
    this.userService.getUsers().subscribe({
      next: (res: any[]) => {
        this.users = (res || [])
          .sort((a, b) => (b.pp_points || 0) - (a.pp_points || 0))
          .map((u, idx) => ({ ...u, rank: idx + 1 }));
        this.isLoading = false;
        console.log("Rankings loaded:", this.users.length, "users");
      },
      error: (error) => {
        console.error("Failed to load rankings:", error);
        this.isLoading = false;
      },
    });
  }

  goToProfile(id: number): void {
    if (!this.currentUser) {
      this.loginPromptService.show(
        "Log in to view player profiles",
        `/profile/${id}`,
      );
      return;
    }
    this.routerService.navigateTo(`profile/${id}`);
  }

  isCurrentUser(id: number): boolean {
    return this.currentUser?.id === id;
  }

  getWinRate(user: any): number | null {
    const wins = user.wins || 0;
    const loses = user.loses || 0;
    const total = wins + loses;

    if (total === 0) return null;
    return Math.round((wins / total) * 100);
  }
}
